import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M22 12.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h7.5",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M18 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6v0Z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "18", cy: "18", r: "3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m22 22-1.5-1.5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "MailSearch";
const MailSearch = memo(themed(Icon));
export {
  MailSearch
};
//# sourceMappingURL=mail-search.js.map
